export const getCommentsContext = (state) => {
  return state.settings.commentsContext;
};

export const getSocialFeedCommunityId = (state) => {
  return state.settings.socialFeedCommunityId;
};

export const getSocialFeedShowInput = (state) => {
  return state.settings.socialFeedShowInput;
};

export default {
  getCommentsContext,
  getSocialFeedCommunityId,
  getSocialFeedShowInput
};
